import { message } from "antd";
import { useContext, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AuthContext } from "../Contexts/AuthContext";
import { AuthModalContext } from "../Contexts/AuthModalContext";

// Sign in and sign up are modals now, but /sign-in and /register still have to
// work: they are all over the app, they are bookmarked, and the e-mail
// verification link points at /sign-in?verified=true. Hitting either URL lands
// the visitor on the home page with the right modal already open.
const AuthModalRoute = ({ mode }) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { isAuthenticated } = useContext(AuthContext);
    const { openSignIn, openRegister } = useContext(AuthModalContext);

    useEffect(() => {
        const verified = searchParams.get("verified");

        if (verified === "true") {
            message.success("Account verified successfully! Please login!");
        } else if (verified === "false") {
            // the link was tampered with, or sat in the inbox past its expiry
            message.error(
                "This verification link is no longer valid. Please register again, or use \"Forgot password?\" to confirm your address."
            );
        }

        if (!isAuthenticated) {
            if (mode === "register") {
                openRegister({ dfCard: Boolean(searchParams.get("df_card")) });
            } else {
                openSignIn();
            }
        }

        navigate("/", { replace: true });
        // one shot on mount: this route exists only to hand over to the modal
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};

export default AuthModalRoute;
